import { useState, useEffect, useCallback, useRef } from "react";

const INTERACTION_THRESHOLD = 5;

/**
 * Cuenta cualquier interacción del usuario (click, keydown) en la página.
 * Devuelve true cuando se alcanza el umbral de interacciones.
 */
const useInteractionCounter = (): boolean => {
  const [reached, setReached] = useState(false);
  const count = useRef(0);

  const handleInteraction = useCallback(() => {
    if (reached) return;
    count.current += 1;
    if (count.current >= INTERACTION_THRESHOLD) setReached(true);
  }, [reached]);

  useEffect(() => {
    if (reached) return;
    document.addEventListener("click", handleInteraction, true);
    document.addEventListener("keydown", handleInteraction, true);
    return () => {
      document.removeEventListener("click", handleInteraction, true);
      document.removeEventListener("keydown", handleInteraction, true);
    };
  }, [handleInteraction, reached]);

  return reached;
};

export default useInteractionCounter;
